import { render, staticRenderFns } from "./FinalScreen.vue?vue&type=template&id=79507322&scoped=true&"
import script from "./FinalScreen.vue?vue&type=script&lang=js&"
export * from "./FinalScreen.vue?vue&type=script&lang=js&"
import style0 from "./FinalScreen.vue?vue&type=style&index=0&id=79507322&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79507322",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
